export const SET_PROPERTY_DATA_RESULTS = 'SET_PROPERTY_DATA_RESULTS';
export const SET_JOB = 'SET_JOB';
export const SET_RECORDS = 'SET_RECORDS';
export const SET_TAGS = 'SET_TAGS';
export const SET_IS_FETCHING_DATA = 'SET_IS_FETCHING_DATA';
export const SET_SEARCH_QUERY = 'SET_SEARCH_QUERY';
export const SET_PROPERTY_DATA_FILTER = 'SET_PROPERTY_DATA_FILTER';
